import React from 'react';
import { 
    Text,
    Spinner, 
    SpinnerSize,
    mergeStyleSets,
    ISpinnerStyles,
} from '@fluentui/react';

const classes = mergeStyleSets({
    container: {
        position: 'fixed',
        left: 0,
        top: 0,
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        zIndex: 999999999,
    },
    content: {
        margin: 'auto',
        height: 'auto',
        width: 'auto',
    },
    text: {
        color: 'white',
        display: 'block',
        marginTop: 10,
    },
});

const spinnerStyles : ISpinnerStyles = {
    circle: {
        width: '50px',
        height: '50px',
        borderWidth: '3px',
        borderColor: 'var(--color-primario) white white',
    },
};

interface ILoaderComponentProps {
    loading: boolean;
    text?: string;
};

const LoaderComponent = (props: ILoaderComponentProps) => {
    return (
        props.loading ? (
            <div className={classes.container}>
                <div className={classes.content}>
                    <Spinner 
                        size={SpinnerSize.large} 
                        styles={spinnerStyles} />
                    <Text className={classes.text}>
                        { props.text || "Cargando" }
                    </Text>
                </div>
            </div>
        ) : (
            null
        )
    );
};

export default LoaderComponent;
